import { all } from "axios";
import customAxios from "./appservices";

export const allContactApi = async (contactData) => {
  console.log({contactData})
  const searchObject = encodeURIComponent(JSON.stringify(contactData.searchObject));
  const data = await customAxios.get(
    `/contacts/allContacts?page=${contactData.page}&limit=${contactData.limit}&searchObject=${searchObject}`
  );
  return data;
};

export const createContactApi = async (data) => {
  return customAxios.post(`/contacts/createContact`, data);
};

export const allUserApi = async (userData) => {
  const data = await customAxios.get(
    `/users/allUsers?page=${userData.page}&limit=${userData.limit}&role=${userData.role}&searchObject=${userData.searchObject}`
  );
  return data;
};

export const createUserApi = async (data) => {
  return customAxios.post(`/users/createUser`, data);
};

export const allAdminApi = async () => {
  const data = await customAxios.get(`/users/allUsers`);
  return data;
};

export const createAdminApi = async (data) => {
  return customAxios.post(`/users/createUser`, data);
};

export const getUserByIdApi = async (id) => {
  return customAxios.get(`/users/allUsers/${id}`);
};

export const getContactByIdApi = async (id) => {
  return customAxios.get(`/contacts/allContacts/${id}`);
};

export const handleCreateContactApi = (id, data) => {
  return customAxios.put(`/contacts/updateContact/${id}`, data);
};

export const handleCreateUserApi = (id, data) => {
  return customAxios.put(`/users/updateUser/${id}`, data);
};

export const deleteContactApi = (id) => {
  return customAxios.delete(`/contacts/deleteContact/${id}`);
};
export const deleteContactManyApi = (data) => {
  return customAxios.delete(`/contacts/deleteContact/`, { data });
};

export const deleteUserApi = (id) => {
  return customAxios.delete(`/users/deleteUser/${id}`);
};

export const deleteUserManyApi = (data) => {
  return customAxios.delete(`/users/deleteUser/`, { data });
};

export const deleteAdminApi = (id) => {
  return customAxios.delete(`/users/deleteAdmin/${id}`);
};
export const deleteAdminManyApi = (data) => {
  return customAxios.delete(`/users/deleteAdmin/`, { data });
};

export const handleLoginApi = (data) => {
  return customAxios.post("/users/login", data);
};

export const downloadPdfApi = async (filter) => {
  console.log(filter)
  const res = await customAxios.post("/contacts/searchContact",filter)
  return res;
}

export const getSuggestion = async () => {
  const res = await customAxios.post("/contacts/getSuggestion", {});
  return res;
};
export const getSuggestionForName = async (txt) => {
  const res = await customAxios.post("/contacts/getSuggestionForName", { txt });
  return res;
};
export const getProjDeptDesig = async () => {
  return await customAxios.get("/users/getProjDeptDesig");
};
export const updateProjDeptDesig = async (type, oldVal, newVal, action) => {
  return await customAxios.post("/users/updateProjDeptDesig", {
    data: {
      type: type,
      oldVal: oldVal,
      newVal: newVal,
      action: action,
    },
  });
};


